






























































import { computed, defineComponent } from '@nuxtjs/composition-api'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import CAlert from '~/components/shared/configurable/alert/CAlert.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CCollapse from '~/components/shared/configurable/collapse/CCollapse.vue'
import PlusMinusCollapseOpener from '~/components/shared/configurable/collapse/PlusMinusCollapseOpener.vue'
import { useI18n } from '~/compositions/i18n'
import { ciTimes } from '~/icons/source/regular/times'
import { marketGuideAdvices } from '~/constants/market-guide'
import { defineComponentTranslations } from '~/utils/i18n'
import { LocaleCode } from '~/models/locale/types'

export default defineComponent({
  components: {
    CCard,
    CAlert,
    CCollapse,
    PlusMinusCollapseOpener
  },
  setup() {
    const { locale, t } = useI18n()

    const bulletPoints = [
      t('from_credit_card'),
      t('from_e_banking_or_viva_wallet'),
      t('received_by_sms_viber_or_whatsapp'),
      t('at_links_sent_to_you')
    ]

    const advices = computed(() => {
      const localeAdvices = marketGuideAdvices[locale as LocaleCode]
      return localeAdvices || marketGuideAdvices.en
    })

    return {
      bulletPoints,
      faExclamationTriangle,
      advices,
      ciTimes
    }
  },
  i18n: defineComponentTranslations({
    below_bullets_text: {
      en: 'They will scam you and you will lose money!',
      el: 'Θα σε εξαπατήσουν και θα χάσεις χρήματα!'
    },
    from_credit_card: {
      en: 'from your Credit Card',
      el: 'από Πιστωτική κάρτα'
    },
    from_e_banking_or_viva_wallet: {
      en: 'from your e-banking or viva wallet',
      el: 'από e-banking ή viva wallet'
    },
    received_by_sms_viber_or_whatsapp: {
      en: 'received by SMS, Viber or WhatsApp',
      el: 'που θα λάβεις σε SMS, Viber ή WhatsApp'
    },
    at_links_sent_to_you: {
      en: 'at links sent to you',
      el: 'σε σύνδεσμο/link που θα σου στείλουν'
    },
    vehicle_market_guide: {
      en: 'Market Guide for Vehicles',
      el: 'Σύμβουλος Αγοράς για Οχήματα'
    },
    do_not_giveaway_passwords: {
      en: 'Do not trust people who will ask you for passwords',
      el: 'Μη δίνεις κωδικούς'
    }
  })
})
